import { useContext } from "react";
import StatsContext from "./statsContext";

const useStatsContext = () => useContext(StatsContext);

export default useStatsContext;
